import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Öneri oluşturma sırasında oluşan hatayı işler
 * @param {Error} error - Oluşan hata
 * @returns {Object} Hata yanıtı: {success, message, error}
 */
export const handleError = (error) => {
  console.error('Error in createSuggestion service:', error)

  const errorMessage = error.message || 'Öneri oluşturulurken bir hata oluştu'
  responseHandlerService.handleError(error, errorMessage)

  return {
    success: false,
    message: errorMessage,
    error,
  }
}